import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
import { DETAIL_MIN_ZOOM_LEVEL } from 'automation-ui-flow-core/canvas/graphConstants';
import { EndMarkerLabel } from 'automation-ui-canvas/components/common/EndMarkerLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledEndMarkerBody = styled.div.withConfig({
  displayName: "EndMarker__StyledEndMarkerBody",
  componentId: "sc-2ytelq-0"
})(({
  borderstyle,
  hidefooter,
  customBorder,
  smallScale,
  disabled,
  theme: _theme
}) => {
  const theme = _theme;
  const style = {
    border: `1px solid ${theme.color['border-core-default']}`,
    display: 'flex',
    padding: '16px',
    width: '250px',
    height: '60px',
    alignItems: 'center',
    justifyContent: 'left',
    borderRadius: `4px 4px ${hidefooter ? '4px 4px' : '0 0'}`,
    background: disabled ? theme.color['fill-surface-raised'] : theme.color['fill-surface-default'],
    borderColor: '',
    borderWidth: '',
    zoom: ''
  };
  if (customBorder) {
    style.borderColor = borderstyle === 'success' ? theme.color['fill-positive-pressed'] : theme.color['fill-alert-default'];
    style.borderWidth = `4px 4px ${hidefooter ? '4px 4px' : '1px 4px'}`;
  }
  if (smallScale) {
    style.zoom = '200%';
    style.width = '150px';
    style.padding = '4px';
  }
  return style;
});
const StyledEndMarkerFooter = styled.div.withConfig({
  displayName: "EndMarker__StyledEndMarkerFooter",
  componentId: "sc-2ytelq-1"
})(({
  borderstyle,
  customBorder,
  theme: _theme
}) => {
  const theme = _theme;
  const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '250px',
    height: '40px',
    padding: '0 16px',
    backgroundColor: theme.color['fill-positive-pressed'],
    color: theme.color['fill-surface-default'],
    borderRadius: '0 0 4px 4px',
    borderColor: '',
    borderWidth: ''
  };
  if (customBorder) {
    style.borderColor = borderstyle === 'success' ? theme.color['fill-positive-pressed'] : theme.color['fill-alert-default'];
    style.borderWidth = '0px 4px 4px 4px';
  }
  return style;
});
const EndMarker = ({
  disabled = false,
  endMarkerFooterText,
  footerTooltipTitle,
  hideFooter = true,
  borderStyle,
  flow,
  edgeId,
  zoomLevel = 1
}) => {
  const prevActionId = getPreviousActionId(edgeId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledEndMarkerBody, {
      disabled: disabled,
      customBorder: !!borderStyle,
      smallScale: zoomLevel < DETAIL_MIN_ZOOM_LEVEL,
      borderstyle: borderStyle,
      hidefooter: hideFooter,
      "data-test-id": `endMarker-${edgeId}`,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "contactProperties",
        size: "xxs",
        className: "p-x-2"
      }), /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: /*#__PURE__*/_jsx(EndMarkerLabel, {
          flow: flow,
          prevActionId: prevActionId
        })
      })]
    }), !hideFooter && /*#__PURE__*/_jsx(UITooltip, {
      title: footerTooltipTitle,
      children: /*#__PURE__*/_jsxs(StyledEndMarkerFooter, {
        customBorder: !!borderStyle,
        borderstyle: borderStyle,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "success",
          size: "xxs"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h5",
          marginBlockEnd: "0",
          paddingInlineStart: "200",
          color: "text-primary-on-fill-default",
          children: endMarkerFooterText
        })]
      })
    })]
  });
};
export default EndMarker;